import React, { useState } from "react";
import { Button, Col, Form, Row, InputGroup, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../../src/asset/css/signIn.css";
import sprintlogo from "../../../src/asset/images/sprintbanner.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { requestResetOtp } from "../api/resetpassword";

const ResetPassword = () => {
  const [email, setEmail] = useState("");

  const [isSending, setIsSending] = useState(false);
  const [emailError, setEmailError] = useState("");
  const navigate = useNavigate();
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value) {
      setEmailError("Please enter your email.");
    } else if (!emailRegex.test(value)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError(""); // valid email
    }
  };
  const handleSendLink = async (e) => {
    e.preventDefault();
    setEmailError("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      setEmailError("Please enter your email.");
      return;
    }

    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }

    setIsSending(true);

    try {
      const response = await requestResetOtp(email);

      if (response.data.statusCode === 200) {
        toast.success(response.data.message);
        setTimeout(() => navigate("/newpassword", { state: { email } }), 500);
      } else if (response.data.statusCode === 404) {
        toast.error("User not found with this email");
        return; // Stop flow
      } else {
        toast.error(response.data.message || "Failed to send OTP");
        return;
      }
    } catch (err) {
      const errorMsg =
        err.response?.data?.message || "User not found with this email";

      toast.error(errorMsg); // 🔥 You MUST show toast here
      return; // STOP execution
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="login-container">
      <Row className="g-0">
        <Col md={6} className="d-none d-md-block">
          <div className="bg_card">
            <div className="mb-2" style={{ textAlign: "center" }}>
              <img src={sprintlogo} alt="Logo" />
            </div>
            <p className="sub_p">
              Manage your educational institution with ease and efficiency.
            </p>
          </div>
        </Col>

        <Col xs={12} md={6}>
          <div className="center-login-card">
            <Card
              className="smooth-shadow-md w-100"
              style={{ maxWidth: "500px" }}
            >
              <Card.Body className="p-4 text-center">
                <div className="mb-3">
                  <i className="bi bi-lock" style={{ fontSize: "40px" }}></i>
                </div>
                <h4 className="mb-3">Trouble logging in?</h4>
                <p className="mb-4">
                  Enter your email and we’ll send you an OTP to reset your
                  password.
                </p>

                <Form onSubmit={handleSendLink}>
                  <Form.Group className="mb-3" controlId="resetEmail">
                    <InputGroup>
                      <InputGroup.Text>
                        <i className="bi bi-envelope-fill"></i>
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Enter your email"
                        value={email}
                        onChange={handleEmailChange}
                        required
                      />
                    </InputGroup>
                    {emailError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "0.875rem",
                          marginTop: "4px",
                        }}
                      >
                        {emailError}
                      </div>
                    )}
                  </Form.Group>

                  <div className="d-grid mb-3">
                    <Button
                      className="loginButton"
                      type="submit"
                      disabled={isSending}
                    >
                      {isSending ? "Sending..." : "Send OTP"}
                    </Button>
                  </div>

                  <div>
                    <span
                      style={{ cursor: "pointer", color: "blue" }}
                      onClick={() => navigate("/")}
                    >
                      Back to login
                    </span>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
      <ToastContainer />
    </div>
  );
};

export default ResetPassword;
